// /src/pages/ExclusiveTab.jsx

import React from 'react';
import PublicLexicalPage from '../../components/PublicLexicalPage';

function ExclusiveTab({ onTocReady, onTocVisibleChange }) {
  return (
    <PublicLexicalPage 
      documentName="Exclusive"
      layout="plain"
      onTocReady={onTocReady}
      onTocVisibleChange={onTocVisibleChange}
    />
  );
}

export default ExclusiveTab;
